import React from 'react';
import PropTypes from 'prop-types';
import UniversalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';
import customText from '../../components/components/custom_text/customText.jsx';
import StatsDataContainer from "./statsDataContainer";

import { ReactComponent as Play } from '../../components/icons/play.svg';
import { ReactComponent as Cup } from '../../components/icons/cup.svg';
import { ReactComponent as MagicStar } from '../../components/icons/magic-star.svg';
import customButton from "../../components/components/custom_button/customButton";

function TrainingsDataContainer({ statsData, tab1Opened, setTab1Opened, tab2Opened, setTab2Opened }) {

    // tab1Opened={trainingsTab1Opened} setTab1Opened={setTab1Opened} tab2Opened={trainingsTab2Opened} setTab2Opened={setTab2Opened}
  // Dane statystyczne podzielone na trzy kolumny
  const { trainingsStats } = statsData;

  return (
    <div className="stats-row-container">
      <div className="stats-column">
          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      icon: Play,
                      text: 'Treningi',
                      baseClass: 'custom-text-header',
                  },
              }]}
              rightSide={[]}
          />
        <UniversalLineWithComponents 
          basicStyle='line-with-components-without-borders' 
          leftSide={[{
            component: customText,
            props: {
              text: 'Zaproponowane',
              baseClass: 'custom-text',
            },
          }]} 
          rightSide={[{
            component: customText,
            props: {
              text: trainingsStats.proposed,
              baseClass: 'custom-text-negative',
              borders: 'LRBT'
            },
          }]} 
        />
        <UniversalLineWithComponents 
          basicStyle='line-with-components-without-borders' 
          leftSide={[{
            component: customText,
            props: {
              text: 'Anulowane',
              baseClass: 'custom-text',
            },
          }]} 
          rightSide={[{
            component: customText,
            props: {
              text: trainingsStats.training_rejected,
              baseClass: 'custom-text-negative',
              borders: 'LRBT'
            },
          }]} 
        />
        <UniversalLineWithComponents 
          basicStyle='line-with-components-without-borders' 
          leftSide={[{
            component: customText,
            props: {
              text: 'Odrzucone',
              baseClass: 'custom-text',
            },
          }]} 
          rightSide={[{
            component: customText,
            props: {
              text: trainingsStats.invitation_rejected,
              baseClass: 'custom-text-negative',
              borders: 'LRBT'
            },
          }]} 
        />
          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      text: 'Zakończone',
                      baseClass: 'custom-text',
                  },
              }]}
              rightSide={[{
                  component: customText,
                  props: {
                      text: trainingsStats.ended,
                      baseClass: 'custom-text-negative',
                      borders: 'LRBT'
                  },
              }]}
          />
          <br />
          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      text: ' ',
                      baseClass: 'custom-text',
                  },
              }]}
              rightSide={[]}
          />
      </div>
      <div className="stats-column">
          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      icon: Cup,
                      text: 'Dyscypliny wybierane najczęściej',
                      baseClass: 'custom-text-header',
                  },
              }]}
              rightSide={[]}
          />
          {Object.entries(statsData.sports)
              .slice(0, tab1Opened ? Object.entries(statsData.sports).length : 4)
              .map(([sport, count]) => (
                  <UniversalLineWithComponents
                      basicStyle='line-with-components-without-borders'
                      leftSide={[{
                          component: customText,
                          props: {
                              text: sport,
                              baseClass: 'custom-text',
                          },
                      }]}
                      rightSide={[{
                          component: customText,
                          props: {
                              text: count,
                              baseClass: 'custom-text-negative',
                              borders: 'LRBT'
                          },
                      }]}
                  />
              ))}
          <br />
          {!tab1Opened && Object.entries(statsData.sports).length > 4 && (
              <UniversalLineWithComponents
                  basicStyle='line-with-components-without-borders'
                  leftSide={[{
                      component: customButton,
                      props: {
                          name: 'Pokaż więcej',
                          baseClass: 'custom-button-white',
                          hoverClass: 'hover-effect',
                          onClick: () => setTab1Opened(true),
                      },
                  }]}
                  rightSide={[]}
              />
          )}
          {tab1Opened && Object.entries(statsData.sports).length > 4 && (
              <UniversalLineWithComponents
                  basicStyle='line-with-components-without-borders'
                  leftSide={[{
                      component: customButton,
                      props: {
                          name: 'Pokaż mniej',
                          baseClass: 'custom-button-white',
                          hoverClass: 'hover-effect',
                          onClick: () => setTab1Opened(false),
                      },
                  }]}
                  rightSide={[]}
              />
          )}


      </div>

        <div className="stats-column">
            <UniversalLineWithComponents
                basicStyle='line-with-components-without-borders'
                leftSide={[{
                    component: customText,
                    props: {
                        icon: MagicStar,
                        text: 'Średnia ocen',
                        baseClass: 'custom-text-header',
                    },
                }]}
                rightSide={[{
                    component: customText,
                    props: {
                        text: statsData.avg_rate,
                        baseClass: 'custom-text-green-negative',
                        borders: 'LRBT',
                        bordersClassPrefix: 'border-green-'
                    },
                }]}
            />
            {Object.entries(statsData.rates)
                .slice(0, tab2Opened ? Object.entries(statsData.rates).length : 4)
                .map(([sport, count]) => (
                    <UniversalLineWithComponents
                        basicStyle='line-with-components-without-borders'
                        leftSide={[{
                            component: customText,
                            props: {
                                text: sport,
                                baseClass: 'custom-text',
                            },
                        }]}
                        rightSide={[{
                            component: customText,
                            props: {
                                text: count,
                                baseClass: 'custom-text-negative',
                                borders: 'LRBT'
                            },
                        }]}
                    />
                ))}
            <br />
            {!tab2Opened && Object.entries(statsData.rates).length > 4 && (
                <UniversalLineWithComponents
                    basicStyle='line-with-components-without-borders'
                    leftSide={[{
                        component: customButton,
                        props: {
                            name: 'Pokaż więcej',
                            baseClass: 'custom-button-white',
                            hoverClass: 'hover-effect',
                            onClick: () => setTab2Opened(true),
                        },
                    }]}
                    rightSide={[]}
                />
            )}
            {tab2Opened && Object.entries(statsData.sports).length > 4 && (
                <UniversalLineWithComponents
                    basicStyle='line-with-components-without-borders'
                    leftSide={[{
                        component: customButton,
                        props: {
                            name: 'Pokaż mniej',
                            baseClass: 'custom-button-white',
                            hoverClass: 'hover-effect',
                            onClick: () => setTab2Opened(false),
                        },
                    }]}
                    rightSide={[]}
                />
            )}
        </div>

    </div>
  );
}

StatsDataContainer.propTypes = {
    statsData: PropTypes.shape({
        trainingsStats: PropTypes.shape({
            proposed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            training_rejected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            invitation_rejected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            ended: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
        sports: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        rates: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        avgRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

    }
)};

export default TrainingsDataContainer;